import { FilterConfigBuilder } from '@juvare/common-data-table-ui/FiltersBar/utils';
import { AccountFilterData } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountList';
import { useExtendedCredentialingAccountsFilters } from '@juvare/credentialing/ui/hooks';
import { useExtendedHanAccountFilters } from './useExtendedHanAccountFilters';

export function useExtendedAccountsFilters() {
    const { extendedHanFilters, environmentConfigError } = useExtendedHanAccountFilters();
    const { extendCredentialingFilters } = useExtendedCredentialingAccountsFilters();

    const extendFilters = (builder: FilterConfigBuilder<AccountFilterData>) => {
        extendedHanFilters(builder);
        extendCredentialingFilters(builder);
    };

    return {
        extendFilters,
        environmentConfigError,
    };
}
